import { subDays } from "date-fns";
import myAxios from "../../utils/axiosWrapper";
import getConfig from "../../conf/config";
import {
  FINANCIAL_INSIGHTS_FETCH,
  FINANCIAL_INSIGHTS_FETCH_SUCCESS,
  FINANCIAL_INSIGHTS_FETCH_FAILURE,
} from "../actionTypes";
import { auth } from "../../conf/firebase";

// Fetch calls between start date and end date
export const getFinancialInsightsSalesKpis = ({ start_date, end_date, dispatched = true }) => {
  return async (dispatch) => {
    try {
      dispatch({ type: FINANCIAL_INSIGHTS_FETCH, payload: { type: "sales_kpis" } });

      // Format dates using toISOString
      const formattedStartDate = new Date(start_date).toISOString();
      const formattedEndDate = new Date(end_date).toISOString();

      const base_url = `${getConfig().API_URL}/audio/api/v1/sales/kpis`;
      const calls_base_url = `${getConfig().API_URL}/audio/api/v1/analytics/calls`;

      // Make Axios request to fetch calls data from the backend
      const promises = [
        myAxios.get(`${base_url}?start_date=${formattedStartDate}&end_date=${formattedEndDate}`),
        myAxios.get(
          `${calls_base_url}?start_date=${formattedStartDate}&end_date=${formattedEndDate}`
        ),
      ];
      const [sales_response, calls_response] = await Promise.all(promises);
      const sales = sales_response.data[0].data;
      sales.total_calls = calls_response.data[0].data?.total_calls || 0;
      if (dispatched) {
        // end
        dispatch({
          type: FINANCIAL_INSIGHTS_FETCH_SUCCESS,
          payload: { type: "sales_kpis", data: sales },
        });
      } else {
        return sales;
      }
    } catch (error) {
      console.log({ error });
      dispatch({ type: FINANCIAL_INSIGHTS_FETCH_FAILURE, payload: error.message });
      throw error;
    }
  };
};

// Fetch calls between start date and end date
export const getFinancialInsightsSales = ({ start_date, end_date, dispatched = true }) => {
  return async (dispatch) => {
    try {
      dispatch({ type: FINANCIAL_INSIGHTS_FETCH, payload: { type: "sales" } });

      // Format dates using toISOString
      const formattedStartDate = new Date(start_date).toISOString();
      const formattedEndDate = new Date(end_date).toISOString();

      const base_url = `${getConfig().API_URL}/audio/api/v1/sales/`;

      // Make Axios request to fetch calls data from the backend
      const response = await myAxios.get(
        `${base_url}?start_date=${formattedStartDate}&end_date=${formattedEndDate}`
      );
      const sales = Object.values(response.data[0].data);
      if (dispatched) {
        // end
        dispatch({
          type: FINANCIAL_INSIGHTS_FETCH_SUCCESS,
          payload: { type: "sales", data: sales },
        });
      } else {
        return sales;
      }
    } catch (error) {
      console.log({ error });
      dispatch({ type: FINANCIAL_INSIGHTS_FETCH_FAILURE, payload: error.message });
      throw error;
    }
  };
};

export const getFinancialInsightsSalesCompanies = ({ start_date, end_date, dispatched = true }) => {
  return async (dispatch) => {
    try {
      dispatch({ type: FINANCIAL_INSIGHTS_FETCH, payload: { type: "sales_companies" } });

      // Format dates using toISOString
      const formattedStartDate = new Date(start_date).toISOString();
      const formattedEndDate = new Date(end_date).toISOString();

      const base_url = `${getConfig().API_URL}/audio/api/v1/sales/companies`;

      // Make Axios request to fetch calls data from the backend
      const response = await myAxios.get(
        `${base_url}?start_date=${formattedStartDate}&end_date=${formattedEndDate}`
      );
      const sales_companies = response.data[0].data;
      if (dispatched) {
        // end
        dispatch({
          type: FINANCIAL_INSIGHTS_FETCH_SUCCESS,
          payload: { type: "sales_companies", data: sales_companies },
        });
      } else {
        return sales_companies;
      }
    } catch (error) {
      console.log({ error });
      dispatch({ type: FINANCIAL_INSIGHTS_FETCH_FAILURE, payload: error.message });
      throw error;
    }
  };
};

export const initFinancialInsights = ({ start_date, end_date }) => {
  return (dispatch, getState) => {
    const { analytics } = getState().analytics;
    // if (analytics.loading) return;
    // const start = new Date("2023-09-10T00:00:00+02:00");
    // const end = new Date("2023-09-15T00:00:00+02:00");
    // const start = start_date || "2023-07-01T00:00:00+02:00";
    // const end = end_date || "2023-12-01T00:00:00+02:00";
    const { currentUser } = auth;
    if (!currentUser || currentUser === null) {
      console.error("Not fetching financial insights, user not authenticated");
      return;
    }

    const today = new Date();

    const start = start_date || subDays(today, today.getDay());
    const end = end_date || today;

    dispatch(getFinancialInsightsSalesKpis({ start_date: start, end_date: end, dispatched: true }));
    dispatch(getFinancialInsightsSales({ start_date: start, end_date: end, dispatched: true }));
    dispatch(
      getFinancialInsightsSalesCompanies({ start_date: start, end_date: end, dispatched: true })
    );
  };
};
